var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600px",
        title: "View Meeting Content",
        visible: _vm.dialogMeetingVisible,
        "split-line": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogMeetingVisible = $event
        },
        close: _vm.onClose,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        { staticClass: "padding-lr", attrs: { "label-width": "190px" } },
        [
          _vm.data
            ? [
                _c("el-form-item", { attrs: { label: "Meeting Title" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.data.CategoryName))]),
                ]),
                _c("el-form-item", { attrs: { label: "PDF Attached" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.data.AttachmentPath, target: "blank" },
                    },
                    [_vm._v(_vm._s(_vm.data.FileName))]
                  ),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "content-container",
                    attrs: { label: "Content" },
                  },
                  [
                    _c("div", {
                      ref: "contentWrapper",
                      staticClass: "content-wrapper",
                      domProps: { innerHTML: _vm._s(_vm.data.PaperContent) },
                    }),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }